import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { yohainous } from 'app/core-node';
import { AES, enc, PBKDF2 } from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class SecureserviceService {
vectorAxis: any = {}
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.vectorAxis = yohainous();
   }
  
  setItem(key: any, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      let valuenew = AES.encrypt(value, this.vectorAxis.nebulaFlux);
      localStorage.setItem(key, valuenew.toString());
      return null;
    } else {
      return null;
    }
  }

  getItem(key: any) {
    if (isPlatformBrowser(this.platformId)) {
      let valuenew = localStorage.getItem(key);
      if (valuenew) {
        let data: any = AES.decrypt(valuenew, this.vectorAxis.nebulaFlux);
        data = data.toString(enc.Utf8);
        return data;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }


}
